export const SITE = {
  url: "https://majimaji.co.ke", // no trailing slash
  name: "MajiMaji Hub",
  legalName: "", // TODO: exact registered name, e.g. "MajiMaji Hub Ltd" (omitted from schema while empty)
  alternateNames: ["Maji Maji Hub", "MajiMaji Hub Ltd", "MajiMaji Water Solutions"],
  logo: "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1791732691/MajiMaji_Water_Solutions_Logo-removebg-preview_jo0zhs.png",
  ogImage:
    "https://res.cloudinary.com/dj6wdsbtx/image/upload/c_fill,w_1200,h_630,q_auto/v1791732731/Golden-Hour_Drilling_in_the_Valley_mcazyh.jpg",
  ogImageAlt: "Borehole drilling rig at golden hour in the valley",
  phone: "+254793025330",
  phoneDisplay: "+254 793 025 330",
  email: "info@majimaji.co.ke",
  geo: { lat: -1.0388, lng: 37.0834 }, // TODO: exact pin from Google Maps
  address: {
    streetAddress: "", // TODO: street / building (omitted while empty)
    addressLocality: "Thika",
    addressRegion: "Kiambu County",
    addressCountry: "KE",
  },
  hours: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "08:00",
    closes: "17:00",
  },
  // TODO: add every real profile: Facebook, Instagram, LinkedIn, TikTok, YouTube, Google Business Profile URL
  sameAs: [],
  countriesServed: ["Kenya"], // add "Uganda", "Tanzania", "Rwanda" only when it's true
  townsServed: ["Thika", "Ruiru", "Juja", "Kiambu", "Nairobi", "Machakos", "Murang'a", "Nyeri", "Embu"],
};